import FuseAnimate from '@/@fuse/core/FuseAnimate';
import * as Actions from '@/app/store/actions';
import { Avatar, CircularProgress, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSubAdminById } from '../../../../services/subSchoolAdmin/SubSchoolAdmin';
import '../addSchoolAdmin/addSchoolAdmin.css';
import { useNavigate } from 'react-router-dom';
import PageHeader from '@/app/customComponents/PageHeader';

const ViewSchoolAdmin = () => {
	const params = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [row, setRow] = useState({
		first_name: '',
		last_name: '',
		email: '',
		phone: '',
	});
	const [isLoading, setIsLoading] = useState(false);
	const [selected, setSelected] = useState([]);
	const [preview, setPreview] = useState(null);

	useEffect(() => {
		let isMounted = true;
		const id = setTimeout(() => {
			if (!isMounted) return;
			getSubAdminById(params?.id)
				.then((res) => {
					if (!isMounted) return;
					setSelected(res.data.permissions);
					setRow({
						first_name: res.data.first_name,
						last_name: res.data.last_name,
						email: res.data.email,
						phone: res.data.phone,
					});
					setPreview(res?.data?.photo);
					setIsLoading(true);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch subadmins, please refresh',
							variant: 'error',
						})
					);
					setIsLoading(true);
				});
		}, 1000);

		return () => {
			isMounted = false;
			clearTimeout(id);
		};
	}, [params?.id]);

	const onBack = () => {
		navigate(-1);
	};
	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="add-schoolAdmin-div mx-auto">
				<div className="mb-[162px] mx-60">
					<div className="flex justify-between items-end my-[40px]">
						<PageHeader onBack={onBack} title="View School Admin" />
					</div>
					<div className="bg-white rounded-12 form-admin-main-div">
						{!isLoading ? (
							<div className="flex justify-center">
								<CircularProgress className="mx-auto" />
							</div>
						) : (
							<div className="form-admin-inner-div">
								<div className="shrink-0 " style={{ marginBottom: '20px' }}>
									<span className="font-bold" style={{ fontSize: '18px' }}>
										Admin Information
									</span>
								</div>
								<div className="bg-white rounded mx-auto" style={{ paddingBottom: '70px' }}>
									<div className="profile-div">
										<div
											// onClick={() => inputRef.current.click()}
											// id="upload-img"
											className="profile-image-div"
										>
											<Avatar className="profile-image" src={preview} style={{ width: 160, height: 160 }} />
										</div>

										<div className="grid grid-cols-2 view-subadmin" style={{ columnGap: 100, rowGap: 40 }}>
											<TextField
												InputLabelProps={{
													style: { color: 'black', fontSize: '18px' },
												}}
												InputProps={{ disableUnderline: true }}
												disabled
												label="First Name"
												name="first_name"
												style={{ width: '100%' }}
												value={row?.first_name}
											/>
											<TextField
												InputLabelProps={{
													style: { color: 'black', fontSize: '18px' },
												}}
												InputProps={{ disableUnderline: true }}
												disabled
												label="Last Name"
												name="last_name"
												style={{ width: '100%' }}
												value={row?.last_name}
											/>
											<TextField
												InputLabelProps={{
													style: { color: 'black', fontSize: '18px' },
												}}
												InputProps={{ disableUnderline: true }}
												disabled
												label="Email Address"
												name="email"
												style={{ width: '100%' }}
												value={row?.email}
											/>
											<TextField
												InputLabelProps={{
													style: { color: 'black', fontSize: '18px' },
												}}
												InputProps={{ disableUnderline: true }}
												disabled
												label="Contact Number"
												name="phone"
												style={{ width: '100%' }}
												value={row?.phone}
											/>
											<div className="">
												<div className="rp-input">Roles/Permission</div>
												<div className="font-bold turncate break input-bottom text-input">
													{selected?.map((roles) => roles?.name?.split('_')?.join(' ')).join(', ')}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default ViewSchoolAdmin;
